<template>
  <button @click="emitClick" type="button">
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5209 1.7L12.3209 0.483348C12.2209 0.383348 12.1042 0.333344 11.9709 0.333344C11.8376 0.333344 11.7042 0.383348 11.6209 0.483348L4.63757 7.56668C4.58757 7.61668 4.55423 7.66668 4.52089 7.73335L3.73757 9.71668C3.6709 9.90002 3.70423 10.1167 3.85423 10.25C3.95423 10.35 4.07089 10.4 4.20422 10.4C4.27089 10.4 4.32091 10.3833 4.38757 10.3667L6.35423 9.58334C6.42089 9.55001 6.47089 9.51668 6.52089 9.46668L13.5042 2.38335C13.7209 2.20002 13.7209 1.88334 13.5209 1.7ZM5.90424 8.7L5.10423 9.01667L5.4209 8.2L11.9709 1.55002L12.4709 2.05002L5.90424 8.7ZM11.0042 8.10001V14.8333C11.0042 15.2 10.6709 15.5 10.3042 15.5H0.837565C0.470898 15.5 0.170898 15.2 0.170898 14.8333V2.13335C0.170898 1.76668 0.470898 1.50001 0.837565 1.50001H7.77089C8.13756 1.50001 8.43756 1.80001 8.43756 2.16668C8.43756 2.53334 8.13756 2.83334 7.77089 2.83334H1.50423V14.1667H9.6709V8.10001C9.6709 7.73334 9.9709 7.43334 10.3376 7.43334C10.7042 7.43334 11.0042 7.73334 11.0042 8.10001Z" fill="#00527F"/>
    </svg>
  </button>
</template>

<script>
  export default {
    name: 'editBtn',
    methods: {
      emitClick() {
        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss" scoped>
  button {
    opacity: 0.5;
    transition: $anim;

    &:hover, &:focus {
      opacity: 1;
    }
  }
</style>
